import {
  style,
  state,
  transition,
  animate,
  keyframes,
  AnimationStateMetadata,
  AnimationTransitionMetadata,
} from '@angular/animations';
import { styleVariables } from '../styles/variables';

export const pgSelectTransitionBackdrop = [
  state(
    'closed',
    style({
      display: 'none',
      opacity: 0,
    })
  ),
  state(
    'open',
    style({
      display: 'block',
      opacity: 0.5,
    })
  ),
  transition(
    'open <=> closed',
    animate(
      `${styleVariables.transitionDurationShort}ms ${styleVariables.transitionCurveSharp}`
    )
  ),
];

export const pgSelectTransitionOptions = [
  state(
    'open',
    style({
      top: '{{top}}',
      left: '{{left}}',

      opacity: 1,
    }),
    { params: { top: '0px', left: '0px' } }
  ),
  state(
    'closed',
    style({
      opacity: 0,
      visibility: 'hidden',
      top: '{{top}}',
      left: '{{left}}',
    }),
    { params: { top: '0px', left: '0px' } }
  ),
  transition(
    ':enter',
    [
      style({
        top: '{{top}}',
        left: '{{left}}',
      }),
      animate('1ms'),
    ],
    { params: { top: '0px', left: '0px' } }
  ),
  transition(
    'open => closed',
    [
      animate(
        `${styleVariables.transitionDurationShort}ms ${styleVariables.transitionCurveAcceleration}`,
        style({
          opacity: 0,
          transform: 'translateY(32px)',
        })
      ),
    ],
    { params: { top: '0px', left: '0px' } }
  ),
  transition(
    'closed => open',
    [
      style({
        visibility: 'visible',
        position: 'fixed',
        opacity: 0,
        transform: 'scale(.85, .68)',
        top: '{{top}}',
        left: '{{left}}',
      }),
      animate(
        `${styleVariables.transitionDurationLong}ms ${styleVariables.transitionCurveStandard}`,
        keyframes([
          style({
            opacity: 0,
            transform: 'scale(.85, .68)',
          }),
          style({
            opacity: 0.5,
            transform: 'scale(1, .75)',
          }),
          style({
            opacity: 1,
            transform: 'scale(1, 1)',
          }),
        ])
      ),
    ],
    { params: { top: '0px', left: '0px' } }
  ),
];
